module.exports = __webpack_public_path__ + "static/media/tracing3.1a3af1dd.png";